/* CasaCalm v2: one small deferred script. No dependencies. */
(function(){
  var d=document,w=window;
  /* scroll reveal */
  var rv=d.querySelectorAll('.rv');
  if('IntersectionObserver' in w && !w.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
    rv.forEach(function(el){if(el.getBoundingClientRect().top>innerHeight){el.classList.add('pre');io.observe(el);}});
  }

  /* menu: close on Escape / link */
  var menu=d.querySelector('[data-menu]');
  if(menu){d.addEventListener('keydown',function(e){if(e.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary').focus();}});
    menu.addEventListener('toggle',function(){d.documentElement.style.overflow=menu.open?'hidden':'';});}

  /* tap to hear: audio fetched only on tap */
  var cur=null;
  function stop(el){if(el&&el._a){el._a.pause();el.classList.remove('playing');var b=el.querySelector('[aria-pressed]');if(b)b.setAttribute('aria-pressed','false');}}
  d.addEventListener('click',function(e){
    var t=e.target.closest('[data-play]');if(!t)return;e.preventDefault();
    var el=t.closest('[data-src]');if(!el)return;
    if(cur&&cur!==el)stop(cur);
    if(!el._a){var a=new Audio();a.preload='none';a.src=el.getAttribute('data-src');var bar=el.querySelector('[data-bar]');
      a.addEventListener('timeupdate',function(){if(bar&&a.duration)bar.style.width=(a.currentTime/a.duration*100)+'%';});
      a.addEventListener('ended',function(){stop(el);if(bar)bar.style.width='0';});el._a=a;}
    if(el.classList.contains('playing')){stop(el);return;}
    el._a.play().then(function(){el.classList.add('playing');cur=el;t.setAttribute('aria-pressed','true');}).catch(function(){});
  });

  /* gallery dots */
  d.querySelectorAll('[data-gal]').forEach(function(g){
    var tr=g.querySelector('.gal__t'),dots=g.querySelectorAll('.gal__dots button'),n=g.querySelector('[data-gal-n]');
    if(!tr)return;var items=tr.children;
    function upd(){var i=Math.round(tr.scrollLeft/tr.clientWidth);dots.forEach(function(b,j){b.setAttribute('aria-current',j===i?'true':'false');});if(n)n.textContent=(i+1)+' / '+items.length;}
    tr.addEventListener('scroll',function(){w.requestAnimationFrame(upd);},{passive:true});
    dots.forEach(function(b,j){b.addEventListener('click',function(){tr.scrollTo({left:j*tr.clientWidth,behavior:'smooth'});});});
  });

  /* qty steppers */
  d.addEventListener('click',function(e){var b=e.target.closest('[data-q]');if(!b)return;var i=b.parentNode.querySelector('input');var v=Math.max(+i.min||0,(+i.value||0)+(+b.getAttribute('data-q')));i.value=v;i.dispatchEvent(new Event('change',{bubbles:true}));});

  /* product form */
  var f=d.getElementById('cc-pf');
  if(f){
    var data=JSON.parse(d.getElementById('cc-pdata').textContent),vid=f.querySelector('[name=id]'),btns=d.querySelectorAll('[data-atc]'),price=d.querySelectorAll('[data-price]'),vlabel=d.querySelectorAll('[data-vlabel]'),main=d.querySelector('.gal__i:first-child img');
    function money(c){return '$'+(c/100).toFixed(2);}
    f.addEventListener('change',function(e){
      if(!e.target.matches('[data-opt]'))return;
      var sel=[].map.call(f.querySelectorAll('[data-opt]:checked'),function(i){return i.value;});
      var v=data.variants.find(function(x){return x.options.every(function(o,k){return o===sel[k];});});
      if(!v)return;vid.value=v.id;
      price.forEach(function(p){p.textContent=money(v.price);});
      vlabel.forEach(function(l){l.textContent=v.title;});
      f.querySelectorAll('[data-opt-name]').forEach(function(s,k){s.textContent=sel[k];});
      btns.forEach(function(b){b.disabled=!v.available;b.querySelector('span').textContent=v.available?'Add to cart':'Sold out';});
      if(v.img&&main){main.srcset=v.img.srcset;main.src=v.img.src;var tr=d.querySelector('.gal__t');if(tr)tr.scrollTo({left:0});}
      history.replaceState(null,'','?variant='+v.id);
    });
    f.addEventListener('submit',function(e){
      if(!w.fetch)return;e.preventDefault();
      btns.forEach(function(b){b.disabled=true;});
      fetch((w.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
        .then(function(r){if(!r.ok)throw r;return fetch('/cart.js');}).then(function(r){return r.json();})
        .then(function(c){d.querySelectorAll('[data-cart-count]').forEach(function(n){n.textContent=c.item_count;n.hidden=!c.item_count;});var t=d.querySelector('[data-toast]');if(t){t.classList.add('on');setTimeout(function(){t.classList.remove('on');},4000);}})
        .catch(function(){f.submit();})
        .finally(function(){btns.forEach(function(b){b.disabled=false;});});
    });
    /* sticky add-to-cart bar (mobile) */
    var sb=d.querySelector('[data-sbar]'),anchor=d.querySelector('[data-buy]');
    if(sb&&anchor&&'IntersectionObserver' in w){new IntersectionObserver(function(es){var e=es[0];sb.classList.toggle('on',!e.isIntersecting&&e.boundingClientRect.top<0);},{threshold:0}).observe(anchor);}
  }

  /* collection sort */
  var so=d.querySelector('[data-sort]');
  if(so)so.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',so.value);location.href=u;});
})();
